import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-account-balance-denied-modal',
  imports: [MatButtonModule, MatDialogModule, MatIconModule],
  templateUrl: './account-balance-denied.component.html',
})
export class AccountBalanceDeniedModalComponent {}
